import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

export const applyPromoCodeMutation = graphql(
  gql`
    mutation getPromoCode($userId: String!, $code: String!) {
      couponCode: getDiscountCodeService(userId: $userId, code: $code, serviceType: "designFee") {
        code
        discountAmount
        type
        rate
        freeShipping
        restrictionType
        products
        discountItemId
        purpose
        eligibleDesigns
        quantities {
          shortId
          quantity
        }
      }
    }
  `,
  {
    name: 'applyPromoCode',
    withRef: true
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/PrintOrderSummary/data.ts